export default __webpack_public_path__ + "static/media/keto_bad_fats.43d8de49.jpg";